export default (classes) => {
  if (typeof classes !== "object") {
    console.error("Invalid argument type for classes. Expected \"object\", got \"" + typeof classes + "\"");
    return "";
  }
  return Object.keys(classes).filter((key) => classes[key]).join(" ");
};
